import { render, staticRenderFns } from "./dentistryThree.vue?vue&type=template&id=272f709b&scoped=true"
import script from "./dentistryThree.vue?vue&type=script&lang=js"
export * from "./dentistryThree.vue?vue&type=script&lang=js"
import style0 from "./dentistryThree.vue?vue&type=style&index=0&id=272f709b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272f709b",
  null
  
)

export default component.exports